import { render, staticRenderFns } from "./NewDailyOffers.vue?vue&type=template&id=282f04ec&scoped=true&"
import script from "./NewDailyOffers.vue?vue&type=script&lang=js&"
export * from "./NewDailyOffers.vue?vue&type=script&lang=js&"
import style0 from "./NewDailyOffers.vue?vue&type=style&index=0&id=282f04ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282f04ec",
  null
  
)

export default component.exports